<template>
  <div id="app">
    <navbar></navbar>
    <router-view/>
    <div style="height: 25px"></div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Buefy from 'buefy';
  import 'buefy/lib/buefy.css';
  import Navbar from './components/Navbar';
  Vue.use(Buefy);

  export default {
    name: 'App',
    components: {
      'navbar': Navbar
    }
  };
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue